/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessSearch
 */
export interface BusinessSearch {
    /**
     * 
     * @type {string}
     * @memberof BusinessSearch
     */
    readonly id: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessSearch
     */
    readonly is_pro: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessSearch
     */
    readonly name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BusinessSearch
     */
    readonly cuisines: Array<string>;
}

/**
 * Check if a given object implements the BusinessSearch interface.
 */
export function instanceOfBusinessSearch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "is_pro" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "cuisines" in value;

    return isInstance;
}

export function BusinessSearchFromJSON(json: any): BusinessSearch {
    return BusinessSearchFromJSONTyped(json, false);
}

export function BusinessSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'is_pro': json['is_pro'],
        'name': json['name'],
        'cuisines': json['cuisines'],
    };
}

export function BusinessSearchToJSON(value?: BusinessSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

